<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />

    <!-- Breadcrumb -->
    <div class="breadcrumb-container">
      <router-link to="/atencion">Atenciones</router-link>
      &rsaquo;
      <router-link
        :to="{
          name: 'AtencionForm',
          state: { idAtencion: p_idAtencion }
        }"
      >
        Atención {{ p_numero }}
      </router-link>
      &rsaquo;
      <router-link
        :to="{
          name: 'AtencionForm',
          state: { idAtencion: p_idAtencion },
          query: { tab: 'tratamiento' }
        }"
      >
        Plan de Tratamiento
      </router-link>
      &rsaquo;
      <b>
        <span v-if="datoPedido.tipo === 'L'">Solicitud Laboratorio Clínico</span>
        <span v-else-if="datoPedido.tipo === 'I'">Solicitud Imagen</span>
      </b>
    </div>
    <hr>

    <!--  Master  -->
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body form-card">

          <div class="mb-3">
            <div class="row align-items-center">
              <div class="col-1"><label class="form-label">Motivo</label></div>
              <div class="col-11">
                <textarea class="form-control" v-model="datoPedido.motivo"
                          style="text-transform:uppercase" required></textarea>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <div class="row align-items-center">
              <div class="col-1"><label class="form-label">Resumen</label></div>
              <div class="col-11">
                <textarea class="form-control" v-model="datoPedido.resumen"
                          style="text-transform:uppercase" required></textarea>
              </div>
            </div>
          </div>

          <button @click.prevent="mostrarBloque = !mostrarBloque">
            {{ mostrarBloque ? '(-) Menos información' : '(+) Más información' }}
          </button>

          <div v-if="mostrarBloque" class="mt-3">
            <div class="mb-3">
              <div class="row align-items-center">
                <div class="col-1"><label class="form-label">Observación</label></div>
                <div class="col-11">
                  <textarea class="form-control" v-model="datoPedido.observacion"
                            style="text-transform:uppercase" required></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-4">
                  <label class="form-label">Id. Pedido</label>
                  <input type="text" class="form-control" :value="datoPedido.idPedido" disabled>
                </div>
                <div class="col-4">
                  <label class="form-label">Fecha de Registro</label>
                  <input type="text" class="form-control"
                         :value="getFormattedDate(datoPedido.fechaReg)" disabled>
                </div>
                <div class="col-4">
                  <label class="form-label">Fecha de Actualización</label>
                  <input type="text" class="form-control"
                         :value="getFormattedDate(datoPedido.fechaAct)" disabled>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="modal-footer">

<Modal v-model:modelValue="showModalDocumentos" :title="tituloPedido">
  <DocVerFirmarGuardar
    :idReporte="datoPedido.tipo === 'L' ? 5 : (datoPedido.tipo === 'I' ? 6 : null)"
    :idDocumento="p_idAtencion"
  />
</Modal>

<!-- Botón que abre el modal de cabecera -->
<button type="button" class="btn btn-light"
        @click="showModalDocumentos = true"
        title="Ver y firmar documento">
  <i class="material-icons" style="font-size:32px;color:red;cursor:pointer">picture_as_pdf</i>
  <span v-if="datoPedido.tipo === 'L'">Solicitud Laboratorio Clínico (Formulario 010A)</span>
  <span v-else-if="datoPedido.tipo === 'I'">Solicitud Imagen (Formulario 012A)</span>
</button>

          <button type="button" class="btn btn-light"
                  @click.prevent="cargarArchivos(datoPedido.idPedido)"
                  title="Resultados">
            <i class="material-icons" style="font-size:32px;color:blue;cursor:pointer">description</i>
            Resultados
          </button>

          <button v-if="btnEditar && estadoPermitido" type="button"
                  class="btn btn-success"
                  @click.prevent="guardarEditPedido()">
            <span class="material-symbols-outlined align-middle" style="font-size:32px">update</span>
            Actualizar
          </button>
        </div>
      </div>
    </div>

    <hr>

    <!--  Barra de búsqueda de detalles  -->
    <div class="mb-3">
      <table class="tablaBusqueda">
        <tr>
          <td>
            <button type="button" class="btn btn-light"
                    @click="showModalPaquete = true"
                    title="Registrar desde paquete"
                    v-if="estadoPermitido">
              <i class="material-icons" style="font-size:24px;color:purple;cursor:pointer">inventory_2</i>
            </button>
          </td>
          <td>
            <button type="button" class="btn btn-light"
                    @click.prevent="cargarDetalles()" title="Todos los registros">
              <i class="material-icons" style="font-size:24px;color:blue;cursor:pointer">auto_awesome_motion</i>
            </button>
          </td>
          <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
          <td><label class="form-label">Tipo</label></td>
          <td>
            <select class="form-select" v-model="tipoBusqueda"
                    @change="buscarPorTipo()">
              <option v-for="(opcion, index) in tipoExamens"
                      :key="index" :value="opcion.idTipoExamen">
                {{ opcion.nombre }}
              </option>
            </select>
          </td>
          <td>
            <button class="btn btn-light"
                    @click="cambiarEstadoPedidoDetTodos(tipoBusqueda, 1)" v-if="estadoPermitido">
              <span class="material-symbols-outlined"
                    style="font-size:24px;color:green;cursor:pointer">check</span>
            </button>
            <button class="btn btn-light"
                    @click="cambiarEstadoPedidoDetTodos(tipoBusqueda, 0)" v-if="estadoPermitido">
              <span class="material-symbols-outlined"
                    style="font-size:24px;color:red;cursor:pointer">close</span>
            </button>
          </td>
        </tr>
      </table>
    </div>

<!--  DataTable  -->
<DataTable
  v-if="datoPedido.idPedido"
  :data="pedidodets"
  :columns="columnas"
  idField="idPedidoDet"
  :acciones="true"
  :mostrarBotonTodos="false"
  :mostrarBotonNuevo="false"
  :mostrarBotonExcel="false"
  :mostrarInfo="false"
  :mostrarEditar="estadoPermitido"
  :mostrarVer="false"
  :mostrarEliminar="false"
  mensajeVacio="No hay exámenes en este pedido."
  @refresh="cargarDetalles()"
  @edit="(row) => abrirModalEditar(row.idPedidoDet)"
>
  <template #cell-estado="{ row }">
    <label class="switch" @click.stop>
      <input type="checkbox"
             v-model="row.estado"
             true-value="1" false-value="0"
             :disabled="!estadoPermitido"
             @change="cambiarEstadoPedidoDet(row.idPedidoDet)">
      <span class="slider round"></span>
    </label>
  </template>

  <template #acciones-fila="{ row }">
    <button
      class="btn btn-sm btn-outline-danger"
      @click="abrirDocumento(row)"
      :title="getTituloPedido(row.tipo)"
    >
      <span class="material-icons" style="font-size:14px">picture_as_pdf</span>
    </button>
  </template>
</DataTable>

<!--  Modal DETALLE (botón por fila del DataTable)  -->
<Modal v-model:modelValue="showModalDocumentoDet" title="Formulario">

  <DocVerFirmarGuardar
    :idReporte="datoPedido.tipo === 'L' ? 5 : (datoPedido.tipo === 'I' ? 6 : null)"
    :idDocumento="p_idAtencion"
  />
  
  <DocVerFirmarGuardar
    :idReporte="5"
    :idDocumento="p_idAtencion"
    :idPedidoDet="pedidoDetSeleccionado?.idPedidoDet"
  />
</Modal>	

    <!--  Modal editar detalle  -->
    <div class="modal fade" id="ventanaModal" tabindex="-1"
         aria-labelledby="modalPedidoDetLabel" aria-hidden="true"
         v-if="modalWindow">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white" id="modalPedidoDetLabel">{{ titulo }}</h5>
            <button type="button" class="btn-close btn-close-white"
                    data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body form-card">
            <div class="mb-3">
              <div class="row">
                <div class="col-12">
                  <div class="mb-1">
                    <span class="form-control-plaintext">{{ pedidoTipoTexto }}</span>
                  </div>
                  <div class="mb-1">
                    <span class="form-control-plaintext">{{ datoPedidoDet.tipoExamenNombre }}</span>
                  </div>
                  <div class="mb-1">
                    <span class="form-control-plaintext">{{ datoPedidoDet.examenNombre }}</span>
                  </div>
                  <label class="form-label">Observación</label>
                  <div class="textarea-container-mic d-flex align-items-stretch">
                    <textarea class="form-control"
                              v-model="datoPedidoDet.observacion"
                              style="text-transform:uppercase"
                              maxlength="250" required></textarea>
                    <div class="buttons-container-mic d-flex flex-column ms-2">
                      <button v-if="!isDictating" type="button"
                              class="btn btn-light" title="Iniciar Dictado"
                              @click="startDictation()">
                        <span class="material-symbols-outlined"
                              style="font-size:40px;color:orangered;cursor:pointer">mic_off</span>
                      </button>
                      <button v-else type="button"
                              class="btn btn-light" title="Finalizar Dictado"
                              @click="stopDictation()">
                        <span class="material-symbols-outlined"
                              style="font-size:40px;color:green;cursor:pointer">mic</span>
                      </button>
                      <div class="flex-grow-1"></div>
                      <small class="text-muted mt-auto text-end">
                        {{ (datoPedidoDet.observacion || '').length }} / 250
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button v-if="btnEditar_det" type="button"
                    class="btn btn-success"
                    @click.prevent="guardarEditPedidoDet()">
              <span class="material-symbols-outlined align-middle"
                    style="font-size:32px">update</span>
              Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>

<Modal v-model:modelValue="showModalPaquete" title="Pedido Paquete">
  <PedidoPaquete
    v-if="showModalPaquete"
    :idAtencion="p_idAtencion"
    :tipo="p_tipo"
    @cancelar="showModalPaquete = false"
    @registrado="onPaqueteRegistrado"
  />
</Modal>
    <Footer />
  </div>
</template>

<script>
import Layout              from '@/components/Layout.vue'
import Footer              from '@/components/Footer.vue'
import PedidoPaquete       from '@/components/PedidoPaquete.vue'
import DataTable           from '@/components/DataTable.vue'
import DocVerFirmarGuardar from '../utils/DocVerFirmarGuardar.vue'
import { validarForm }     from '@/modules/validacionesForms.js'
import dateFormat          from '@/modules/dateFormat.js'
import SpeechDictation     from '@/modules/microfono.js'
import api                 from '@/services/api'
import { openModal, closeModal } from '@/modules/modalHelper.js'
import swal                from 'sweetalert'

export default {
  name: 'PedidoForm',

props: {
  p_idAtencion:     { type: Number, required: true },
  p_estadoAtencion: { type: String, required: true },
  p_tipo:           { type: String, required: true },  // 'I' o 'L'
  p_numero:         { type: String, required: true },
},

  components: { Layout, Footer, DataTable, DocVerFirmarGuardar, PedidoPaquete },

  data() {
    return {
      // Master
      datoPedido:            {},
      btnCrear:              false,
      btnEditar:             false,
      mostrarBloque:         false,
      showModalDocumentos:   false,
      showModalDocumentoDet: false,
      showModalPaquete:      false,
      pedidoDetSeleccionado: null,

      // Detalle
      pedidodets:          [],
      datoPedidoDet:       {},
      nombreBusqueda:      '',
      tipoBusqueda:        '',
      titulo:              '',
      btnEditar_det:       false,
      modalWindow:         true,
      tipoExamens:         [],
      dictation:           new SpeechDictation(),
      isDictating:         false,

      columnas: [
        { field: 'tipoExamenNombre', label: 'Tipo' },
        { field: 'examenNombre',     label: 'Nombre' },
        { field: 'observacion',      label: 'Observación' },
        { field: 'estado',           label: 'Estado' },
        { field: 'idPedidoDet',      label: 'idPedidoDet' },
      ],
    }
  },

  computed: {
    estadoPermitido() {
      return ['PENDIENTE', 'PROCESO'].includes(this.p_estadoAtencion)
    },
    pedidoTipoTexto() {
      return { 'I': 'Imagen', 'L': 'Laboratorio' }[this.datoPedidoDet.pedidoTipo] ?? ''
    },
    tituloPedido() {
      if (this.datoPedido.tipo === 'L') return 'Formulario O10A - Solicitud Laboratorio Clínico'
      if (this.datoPedido.tipo === 'I') return 'Formulario O12A - Solicitud Imagen'
      return 'Formulario'
    },
  },

  watch: {
    nombreBusqueda(v) { if (v) this.tipoBusqueda = '' },
    tipoBusqueda(v)   { if (v) this.nombreBusqueda = '' },
  },

  async mounted() {
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    await this.abrirEditar(this.p_idAtencion, this.p_tipo)
    this.cargarDetalles()
    this.fetchTipoExamen()
  },

  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date)
    },

    //  Master
    validarForm() {
      return validarForm(
        this.datoPedido,
        ['idTratamiento', 'observacion'],
        ['idTratamiento', 'observacion']
      )
    },

    async guardarEditPedido() {
      if (this.validarForm() !== 1) return
      try {
        await api.post('/pedidos', this.datoPedido)
        swal('Correcto!', 'Pedido actualizado exitosamente!', 'success')
      } catch (error) {
        swal('Error!', 'Inténtelo de nuevo!', 'error')
        if (error.response?.data?.errors) {
          Object.values(error.response.data.errors).forEach(e => swal(String(e)))
        }
      }
    },

    async abrirEditar(idAtencion, tipo) {
      if (idAtencion && tipo) {
        const { data } = await api.get(`/vwpedidos/idatencion-tipo/${idAtencion}/${tipo}`)
        this.datoPedido = data
      }
      this.btnCrear  = false
      this.btnEditar = true
    },

    cargarArchivos(idPedido) {
//      this.$router.push(`/pedido_archivo/${this.p_idAtencion}/${this.p_tipo}/${this.p_numero}/${idPedido}`)
//      this.$router.push(`/pedido_archivo/${this.p_idAtencion}/${this.p_estadoAtencion}/${this.p_tipo}/${this.p_numero}/${idPedido}`)
      this.$router.push({
        name: 'Pedido_Archivo',
        state: {
          idAtencion:     this.p_idAtencion,
          estadoAtencion: this.p_estadoAtencion,
          tipo:           this.p_tipo,
          numero:         this.p_numero,
          idPedido:       idPedido,
        }
      });
    },

    //  Detalles
    cargarDetalles() {
      if (!this.datoPedido.idPedido) return
      api.get(`/vwpedidodets/idpedido/${this.datoPedido.idPedido}`)
        .then(response => { this.pedidodets = response.data.reverse() })
        .catch(error   => console.error('Error cargando detalles:', error))
    },

    buscarPorNombre() {
      if (!this.nombreBusqueda) { this.cargarDetalles(); return }
      api.get(`/vwpedidodets/idpedido/${this.datoPedido.idPedido}/nombreexamen/${this.nombreBusqueda}`)
        .then(response => { this.pedidodets = response.data.reverse() })
        .catch(error   => console.error('Error buscando:', error))
    },

    buscarPorTipo() {
      if (!this.tipoBusqueda) { this.cargarDetalles(); return }
      api.get(`/vwpedidodets/idpedido/${this.datoPedido.idPedido}/idtipoexamen/${this.tipoBusqueda}`)
        .then(response => { this.pedidodets = response.data.reverse() })
        .catch(error   => console.error('Error buscando:', error))
    },

    fetchTipoExamen() {
      const tipo = { 'I': 'IMAGEN', 'L': 'LABORATORIO' }[this.p_tipo] ?? 'Tipo no definido'
      api.get(`/vwtipoexamens/tipo/${tipo}`)
        .then(response => { this.tipoExamens = response.data })
        .catch(error   => console.error('Error fetching tipos:', error))
    },

    async cambiarEstadoPedidoDet(idPedidoDet) {
      try {
        await api.put(`/pedidodets/actualizarEstado/${idPedidoDet}`)
      } catch {
        swal('Error!', 'Inténtelo de nuevo!', 'error')
      }
    },

    async cambiarEstadoPedidoDetTodos(idTipoExamen, estado) {
      if (!this.tipoBusqueda) {
        swal('Error!', 'Seleccione un tipo para la búsqueda!', 'error')
        return
      }
      try {
        await api.put(`/pedidodets/actualizarestado-tipoexamen?idPedido=${this.datoPedido.idPedido}&idTipoExamen=${idTipoExamen}&estado=${estado}`)
        swal('Correcto!', 'Estado actualizado exitosamente!', 'success')
        this.buscarPorTipo()
      } catch {
        swal('Error!', 'No se pudo cambiar el estado.', 'error')
      }
    },

    async guardarEditPedidoDet() {
      if (this.validarForm() !== 1) return
      try {
        await api.post('/pedidodets', this.datoPedidoDet)
        closeModal('ventanaModal')
        swal('Correcto!', 'Detalle actualizado exitosamente!', 'success')
        this.cargarDetalles()
      } catch (error) {
        swal('Error!', 'Inténtelo de nuevo!', 'error')
        if (error.response?.data?.errors) {
          Object.values(error.response.data.errors).forEach(e => swal(String(e)))
        }
      }
    },

    abrirModalEditar(idPedidoDet) {
      this.modalWindow = true
      if (idPedidoDet) {
        api.get(`/vwpedidodets/${idPedidoDet}`)
          .then(resp => { this.datoPedidoDet = resp.data })
      }
      this.titulo        = 'Editar Pedido'
      this.btnEditar_det = true
      openModal('ventanaModal')
    },

    //  Micrófono
    startDictation() {
      this.isDictating = true
      this.dictation.startDictation(
        transcript => { this.datoPedidoDet.observacion = transcript },
        this.datoPedidoDet.observacion
      )
    },
    stopDictation() {
      this.isDictating = false
      this.dictation.stopDictation()
    },
    onPaqueteRegistrado(data) {
      this.showModalPaquete = false
      this.abrirEditar(this.p_idAtencion, this.p_tipo).then(() => {
        this.cargarDetalles()
      })
      swal('Correcto!', `Pedido #${data.idPedido} registrado con ${data.totalExamenes} examen(s).`, 'success')
    },
    getTituloPedido(tipo) {
      if (tipo === 'L') return 'Formulario O10A - Solicitud Laboratorio Clínico'
      if (tipo === 'I') return 'Formulario O12A - Solicitud Imagen'
      return 'Formulario'
    },
    abrirDocumento(row) {
      this.pedidoDetSeleccionado = row
      this.showModalDocumentoDet = true
    },
  },
}
</script>

<style src="@/assets/css/interruptor.css" scoped></style>
<style src="@/assets/css/microfono.css" scoped></style>	